import { COOKIE_KEYS } from 'common/constants';
import { localStorageClear, localStorageGet, localStorageRemove } from 'common/local-storage';
import { LOCAL_STORAGE_KEYS } from 'src/common/local-storage/constants';

// todo: remove unused

type UserInfoType = {
  token?: string;
  user?: {
    id: number;
    registered: boolean;
    profile: ProfileType;
  };
};

type ProfileType = {
  firstName: string;
  lastName: string;
  pictureUrl?: string;
  phoneNumber: string;
  // some other data that is useless in our case
};

// core duplicate with some changes
export const setLoginInfo = (loginData: UserInfoType, overwrite = true) => {
  if (!overwrite) {
    const currentLoginInfo = getLoginInfo();
    const newLoginInfo = { ...currentLoginInfo, ...loginData };
    setCookieObject(COOKIE_KEYS.LOGIN_INFO, newLoginInfo);
  } else setCookieObject(COOKIE_KEYS.LOGIN_INFO, loginData);
};

// core duplicate with some changes
export const getLoginInfo = (): UserInfoType | null => {
  try {
    let item = getCookie(COOKIE_KEYS.LOGIN_INFO);
    if (item) {
      item = decodeURIComponent(item);
      return JSON.parse(item);
    }
    return localStorageGet(LOCAL_STORAGE_KEYS.LOGIN_INFO);
  } catch (err) {
    console.log(`Could not find the loginInfo`);
  }
  return null;
};

// core duplicate with some changes
export const isLoggedIn = (): boolean => {
  const token = getLoginInfo()?.token;
  return Boolean(token && token !== 'null' && token !== 'undefined');
};

// core duplicate with some changes
// todo: remove usage
export function clearSessionInfo() {
  eraseCookie(COOKIE_KEYS.LOGIN_INFO);
  localStorageRemove(COOKIE_KEYS.LOGIN_INFO);
}

export function removeUserData(clearAllData = false) {
  if (typeof window !== 'undefined') {
    clearSessionInfo();
    if (clearAllData) {
      localStorageClear();
      sessionStorage.clear();
    }
  } else {
    console.log('Can not log out in server environment');
    console.trace();
  }
}

// core duplicate
export function setCookie(name: string, value: string, seconds: number, domain?: string) {
  let cookie = setCookieString(name, value, seconds);
  if (domain) {
    cookie += `; domain=${domain}`;
  }
  document.cookie = cookie;
}

// core duplicate
export function setCookieString(name: string, value: string, seconds: number) {
  let expires = '';
  if (seconds) {
    const date = new Date();
    date.setTime(date.getTime() + seconds * 1000);
    expires = `; expires=${date.toUTCString()}`;
  }
  return `${name}=${value || ''}${expires}; path=/`;
}

// core duplicate
export function eraseCookie(name: string, domain?: string) {
  setCookie(name, '', -99999999, domain);
}

// core duplicate
export function setCookieObject(key: string, object: unknown, seconds: number = 30 * 24 * 60 * 60) {
  try {
    setCookie(key, encodeURIComponent(JSON.stringify(object)), seconds);
  } catch (err) {
    console.log(`Could not save the ${key} in cookie`);
  }
}

// core duplicate
export function getCookie(name: string, state?: { runtime?: { cookie?: string } }) {
  let cookie;
  if (state?.runtime?.cookie) {
    cookie = state.runtime.cookie;
  } else if (typeof window !== 'undefined') {
    cookie = window.document.cookie;
  } else {
    cookie = global?.document?.cookie;
  }
  if (!cookie) {
    return null;
  }
  return getCookieFrom(name, cookie);
}

// core duplicate
export function getCookieFrom(name: string, cookie: string) {
  const nameEQ = `${name}=`;
  const ca = cookie.split(';');
  const { length } = ca;
  let i = 0;
  for (; i < length; i += 1) {
    let c = ca[i];
    while (c.startsWith(' ')) {
      c = c.substring(1, c.length);
    }
    if (c.startsWith(nameEQ)) {
      return c.substring(nameEQ.length, c.length);
    }
  }
  return null;
}
